import React from 'react';
import PropTypes from 'prop-types';

const LockIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 14.748">
        <g>
            <path d="M9.64 4.983V2.422A2.425 2.425 0 007.219 0H4.8a2.425 2.425 0 00-2.422 2.422v2.561A2.412 2.412 0 000 7.389v4.952a2.408 2.408 0 002.406 2.406h7.187A2.408 2.408 0 0012 12.341V7.389a2.4 2.4 0 00-2.36-2.406zM4.8 1.568h2.422a.855.855 0 01.854.869V5H3.927V2.422a.855.855 0 01.873-.854zm5.651 10.773a.861.861 0 01-.854.854H2.406a.861.861 0 01-.854-.854V7.389a.861.861 0 01.854-.854h7.187a.861.861 0 01.854.854z" fill={fill} />
        </g>
    </svg>
);

LockIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

LockIcon.defaultProps = {
    width: '12',
    height: '14.748',
    fill: '#4b254e'
};

export default LockIcon;
